// extracted by mini-css-extract-plugin
module.exports = {"sectionTwo":"SectionTwo_sectionTwo__2SI7G","title":"SectionTwo_title__qwrOW","subTitle":"SectionTwo_subTitle__3rIue","content":"SectionTwo_content__cgqSA"};